import React, { useEffect, useMemo, useState } from "react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  FormLabel,
  Grid,
  List,
  ListItem,
  Popover,
  Tab,
  Tabs,
} from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import DownloadIcon from "@mui/icons-material/Download";
import StartTime from "./app_components_start-time";
import FinishTime from "./app_components_finish-time";
import RealTimeCapture from "./app_components_real-time-capture";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import ClearIcon from "@mui/icons-material/Clear";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Typography from "@mui/material/Typography";
import axiosInstance from "../../../../../axios/axiosInstance";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../../../../actions/actions";
import { Scrollbars } from "rc-scrollbars";
import InnerPageheading from "../../../../../components/InnerPageheading";
import FinishTimeEntryHeaderBox from "./app_components_finish-time-header-box";
import SessionNotesTab from "./SessionNotesTab";
import CustomizedSnackbars from "../../../../../components/Toast";
import { encrypt } from "../../../../global/helperFunctions";
import CircularProgress from "@mui/material/CircularProgress";
import TabletPortraitBlocker from "../../../../global/TabletPortraitBlocker";

export default function RaceManager() {
  var encryptedClubId = encodeURIComponent(
    encrypt(localStorage.getItem("club_id")),
  );
  var encryptedUserId = encodeURIComponent(
    encrypt(localStorage.getItem("user_id")),
  );

  const queryParameters = new URLSearchParams(window.location.search);
  const tabName = queryParameters.get("tab");
  const raceSessionIdQ = queryParameters.get("raceSessionId");

  const [activeTab, setActiveTab] = useState(tabName ? tabName : "start");
  const [isLocked, setIsLocked] = useState(false);
  const [caseOTBEntrant, setCaseOTBEntrant] = useState(false);
  const [captureTime, setCaptureTime] = useState("00:00:00");
  const [rows, setRows] = useState([]);
  const [savedFleetDetails, setSavedFleetDetails] = useState([]);
  const [processFlag, setProcessFlag] = useState(false);
  const [isProcessClickedByMe, setIsProcessClickedByMe] = useState(false);
  const [isOnRace, setIsOnRace] = React.useState(false);
  const [raceSession, setRaceSession] = React.useState(0);
  const [raceSessionNotes, setRaceSessionNotes] = React.useState("");
  const [numEntrants, setNumEntrants] = React.useState(-1);
  const [payload, setPayload] = React.useState({});
  const [unfinishedEntrants, setUnfinishedEntrants] = React.useState([]);
  const [isPlace, setIsPlace] = React.useState(false);
  const [allPenalties, setAllPenalties] = React.useState([]);
  const timePenalties = ["ARB", "ENP", "SCP", "ZFP", "ESP", "RDG", "OCS", "DNF", "RET", "DSQ", "BFD", "UFD"];
  const [eventId, setEventId] = React.useState("");
  const [sessionDate, setSessionDate] = React.useState("");
  const [changeSort, setChangeSort] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [snackbar, setSnackbar] = React.useState({ text: "", severity: "" });
  const initialFinishRaceEntrants = useSelector(
    (state) =>
      state.initialFinishRaceEntrantsList.initialFinishRaceEntrantsList.data,
  );

  const aboutFinishRaceEntrants = useSelector(
    (state) =>
      state.aboutFinishRaceEntrantsList.aboutFinishRaceEntrantsList.data,
  );
  const completeFinishRaceEntrants = useSelector(
    (state) =>
      state.completeFinishRaceEntrantsList.completeFinishRaceEntrantsList.data,
  );

  const dispatch = useDispatch();
  const [importTimes, setImportTimes] = React.useState([]);
  const [file, setFile] = React.useState();
  const [array, setArray] = React.useState([]);
  const fileReader = new FileReader();

  const [fileName, setFileName] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [loader, setLoader] = React.useState(false);

  const isOnWaterDisabled = useMemo(() => {
    console.log("isOnWaterDisabled running");
    const today = new Date();
    const session = new Date(sessionDate);
    today.setHours(0, 0, 0, 0);
    session.setHours(0, 0, 0, 0);

    return Math.abs((today - session) / (1000 * 60 * 60 * 24)) > 1;
  }, [sessionDate]); // recompute only if sessionDate changes

  // const navigate = useNavigate();

  // useEffect(() => {
  //   return () => {
  //     console.log("User is leaving the screen...");
  //     // Perform cleanup actions here (e.g., unlock a screen)
  //     releaseLock();
  //   };
  // }, [navigate]);

  // const checkLockStatus = async () => {
  //   try {
  //     const response = await axiosInstance.get(
  //       "api/clubs/FinishTime/check-lock"
  //     );
  //     setIsLocked(response.data.data);
  //     if (!response.data.data) {
  //       requestLock();
  //     }
  //   } catch (error) {
  //     console.error("Error checking lock:", error);
  //   }
  // };

  // const requestLock = async () => {
  //   try {
  //     const response = await axiosInstance.post(
  //       `api/clubs/FinishTime/request-lock?userId=${encryptedUserId}&raceSessionId=${raceSession}&lock=true`
  //     );
  //     // making condition false for current time
  //     // setIsLocked(response.data.data);
  //     setIsLocked(true);
  //   } catch (error) {
  //     setIsLocked(true);
  //     console.error("Error requesting lock:", error);
  //   }
  // };

  // const releaseLock = async () => {
  //   try {
  //     const response = await axiosInstance.post(
  //       `api/clubs/FinishTime/request-lock?userId=${encryptedUserId}&raceSessionId=${raceSession}&lock=false`
  //     );
  //     // setIsLocked(response.data.data);
  //     setIsLocked(false);
  //   } catch (error) {
  //     setIsLocked(false);
  //     console.error("Error releasing lock:", error);
  //   }
  // };

  /*  useEffect(() => {
    checkLockStatus();
    const interval = setInterval(checkLockStatus, 5000); // Check every 5s

    return () => clearInterval(interval);
  }, []); */

  React.useEffect(() => {
    setActiveTab(tabName);
  }, [tabName]);

  React.useEffect(() => {
    if (raceSession && raceSessionIdQ) {
      setRaceSession(raceSessionIdQ);
    }
  }, [raceSession, raceSessionIdQ]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setFile(null);
    setFileName("");
  };

  const openUploadFile = Boolean(anchorEl);
  const id = openUploadFile ? "select_source" : undefined;

  const handleFileClear = () => {
    setFile(null);
  };

  React.useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = ""; // Required for modern browsers to show the prompt
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  const makePayloadForUpdate = (obj) => {
    console.log("THE OBJ", obj);
    let targetObj = {};
    const isCapturedNow = obj.editable;
    targetObj["raceSessionId"] = raceSession;
    if (obj.status != undefined) {
      targetObj["sessionEntrantId"] = isCapturedNow ? "" : obj.sessionEntrantId;
    } else {
      targetObj["sessionEntrantId"] = isCapturedNow ? "" : obj.id;
    }

    targetObj["place"] = obj.position;
    targetObj["sailNum"] = obj.sailNum;
    targetObj["hr"] = obj.hr.toString().padStart(2, "0");
    targetObj["mm"] = obj.min.toString().padStart(2, "0");
    targetObj["ss"] = obj.sec.toString().padStart(2, "0");
    targetObj["date"] = sessionDate;
    targetObj["dn"] = obj.dn;
    targetObj["fleet"] = obj.fleetName;
    return targetObj;
  };

  const formatNum = (num) => {
    if (num >= 10) {
      return num.toString();
    } else {
      return "0" + num.toString();
    }
  };

  const saveRows = async (data, finishedRows) => {
    const UPDATE_FINISH_TIMES = `api/clubs/FinishTime/list`;
    console.log("the Payload", data);
    console.log("the finishedRows", finishedRows);
    let response = "";
    try {
      response = await axiosInstance.post(UPDATE_FINISH_TIMES, data);

      console.log("Response:", response.data);

      if (response.data.success && Array.isArray(response.data.data)) {
        const editableMap = new Map(
          response.data.data.map((item) => [item.sailNum, item.editable]),
        );

        const updatedCompleteFinishRaceEntrants = finishedRows.map(
          (entrant) => {
            if (editableMap.has(entrant.sailNum)) {
              return {
                ...entrant,
                editable: editableMap.get(entrant.sailNum),
              };
            }
            return entrant;
          },
        );
        console.log("THE ENTRANTS", updatedCompleteFinishRaceEntrants);
        dispatch(
          actions.updateCompleteFinishRaceEntrants(
            updatedCompleteFinishRaceEntrants,
          ),
        );
      }
    } catch (error) {
      console.log("the data 123", data);
      handleSnackbarChange("Error occured while importing.", "error", true);

      /*  let finishedRow = completeFinishRaceEntrants.filter(x=>x.sailNum === data.sailNum);
      console.log("the error finishedRow",finishedRow)
      if(finishedRow){
        let updatedCompleteFinishRaceEntrants = completeFinishRaceEntrants.map((entrant) => 
          entrant.sailNum === data.sailNum ? { ...entrant, editable: true } : entrant
        );
        console.log("the error row",updatedCompleteFinishRaceEntrants)
        dispatch(
          actions.updateCompleteFinishRaceEntrants(updatedCompleteFinishRaceEntrants)
        );
      } */
      // if(!response.data.success){
      // Handle errors
      console.error("Error updating finish times:", error);
      //  }
    } finally {
    }
  };

  React.useEffect(() => {
    let validTimes = [];
    let invalidTimes = [];
    let counter = 0;
    //console.log("importTimes",importTimes)
    if (importTimes != undefined && completeFinishRaceEntrants) {
      if (completeFinishRaceEntrants.length == 0 && importTimes.length > 0) {
        importTimes.forEach((i) => {
          if (
            i.SailNo != undefined &&
            i.SailNo != "" &&
            i.Boat != "---" &&
            i.Fleet != "---" &&
            (i.Place === undefined ||
              !isPlace ||
              (isPlace &&
                i.Place?.trim() !== "" &&
                isNumeric(i.Place) &&
                i.Place > 0) ||
              i.DidNot !== "") &&
            (i.HR == undefined || isNumeric(i.HR) || i.HR == "") &&
            (i.MN == undefined || isNumeric(i.MN) || i.MN == "") &&
            (i.SC == undefined || isNumeric(i.SC) || i.SC == "") &&
            (i.DidNot.trim() == "" ||
              (i.DidNot.trim() != "" &&
                allPenalties
                  .map((x) => x.penaltyName)
                  .includes(i.DidNot.trim().toUpperCase())))
          ) {
            let sailNo = i.SailNo;
            let row = initialFinishRaceEntrants.filter((x) => {
              if (
                x?.sailNum &&
                x?.sailNum?.toUpperCase() === i?.SailNo?.toUpperCase() &&
                (x?.boatName?.toUpperCase() === i?.Boat?.toUpperCase() ||
                  (caseOTBEntrant &&
                    x.boatName?.toUpperCase() === i?.Class?.toUpperCase()))
              ) {
                return x;
              } else {
                return null;
              }
            });
            console.log("row", row);
            let existingTime = validTimes.filter((f) => {
              return (
                f.sailNum.toUpperCase() === i.SailNo.toUpperCase() &&
                f.boatName.toUpperCase() === i.Boat.toUpperCase()
              );
            });

            if (row.length > 0 && existingTime.length == 0) {
              counter++;
              row[0].position = isPlace ? i.Place : counter;
              row[0].place = isPlace ? i.Place : counter;
              row[0].dn = i.DidNot != undefined ? i.DidNot.toUpperCase() : "";
              if (
                i.DidNot != "" &&
                !timePenalties.includes(i.DidNot.toUpperCase())
              ) {
                row[0].hr = "00";
                row[0].min = "00";
                row[0].sec = "00";
                row[0].errorHr = false;
                row[0].errorMin = false;
                row[0].errorSec = false;
              } else {
                row[0].hr =
                  i.HR != undefined && i.HR != ""
                    ? i.HR.length == 1
                      ? "0" + i.HR
                      : i.HR > 23
                        ? "23"
                        : i.HR
                    : "00";
                row[0].min =
                  i.MN != undefined && i.MN != ""
                    ? i.MN.length == 1
                      ? "0" + i.MN
                      : i.MN > 59
                        ? "59"
                        : i.MN
                    : "00";
                row[0].sec =
                  i.SC != undefined && i.SC != ""
                    ? i.SC.length == 1
                      ? "0" + i.SC
                      : i.SC > 59
                        ? "59"
                        : i.SC
                    : "00";
                row[0].errorHr =
                  i.HR != undefined && i.HR.length > 2 ? true : false;
                row[0].errorMin =
                  i.MN != undefined && i.MN.length > 2 ? true : false;
                row[0].errorSec =
                  i.SC != undefined && i.SC.length > 2 ? true : false;
              }

              validTimes.push(row[0]);
            }
          } else {
            invalidTimes.push(i);
          }
        });

        validTimes = isPlace
          ? [...validTimes].sort((a, b) => b.place - a.place)
          : [...validTimes].sort((a, b) => b.position - a.position);
        let unfinished = initialFinishRaceEntrants.filter(
          (r) => !validTimes.map((v) => v.id).includes(r.id),
        );

        dispatch(actions.updateInitialFinishRaceEntrants(unfinished));
        dispatch(actions.updateCompleteFinishRaceEntrants(validTimes));

        let payload = validTimes.map((e) => {
          return makePayloadForUpdate(e);
        });
        saveRows(payload, validTimes);

        setImportTimes([]);
        handleSnackbarChange(
          validTimes.length +
            " out of " +
            importTimes.length +
            " valid entrants imported successfully",
          "success",
          true,
        );
        handleClose();
        setLoader(false);
      }
    }
  }, [importTimes]);

  // const handleOnChange = (e) => {
  //   setFile(e.target.files[0]);
  // };

  const handleOnChange = (e) => {
    const selectedFile = e.target.files[0]; // Get the selected file
    setFile(selectedFile); // Update the file state
    if (selectedFile) {
      setFileName(selectedFile.name); // Update the fileName state
    }
  };

  const csvFileToArray = (string) => {
    const csvHeader = string
      .slice(0, string.indexOf("\n"))
      .split(",")
      .map((header) => header.trim().replace(/\r$/, ""));
    console.log("The header", csvHeader);
    if (
      (!isPlace &&
        (!csvHeader.includes("HR") ||
          !csvHeader.includes("MN") ||
          !csvHeader.includes("SC"))) ||
      !csvHeader.includes(caseOTBEntrant ? "Class" : "Boat") ||
      !csvHeader.includes("Sail No") ||
      !csvHeader.includes("DidNot")
    ) {
      handleSnackbarChange("Please select a valid CSV File.", "error", true);
      handleClose();
      return;
    }
    const csvRows = string
      .slice(string.indexOf("\n") + 1)
      .split("\n")
      .filter((row) => row.trim() !== "");

    if (csvRows.length == 0) {
      handleSnackbarChange("No Rows Found.", "error", true);
      handleClose();
      return;
    }
    const array = csvRows.map((i) => {
      const values = i.split(",");
      const obj = csvHeader.reduce((object, header, index) => {
        object[header.replace(" ", "")] = values[index]
          ?.trim()
          .replace(/\r$/, "");
        return object;
      }, {});
      return obj;
    });
    console.log("The array", array);
    importFinishTimes(array);
    setArray(array);
  };

  const importFinishTimes = (times) => {
    let arr2 = [];
    console.log("The finishedEntrants", completeFinishRaceEntrants);
    console.log("The preFinishedEntrants", aboutFinishRaceEntrants);
    console.log("The initialFinishRaceEntrants", initialFinishRaceEntrants);
    // toggle changeSort so child RealTimeCapture can react on every import
    setChangeSort((prev) => !prev);
    if (times.length > 0) {
      setLoader(true);
      for (let i = 0; i < initialFinishRaceEntrants.length; i++) {
        arr2.push(initialFinishRaceEntrants[i]);
      }
      for (let i = 0; i < completeFinishRaceEntrants.length; i++) {
        if (
          completeFinishRaceEntrants[i].sailNum != "" &&
          completeFinishRaceEntrants[i].boatName != "---" &&
          completeFinishRaceEntrants[i].fleetName != "---"
        ) {
          completeFinishRaceEntrants[i].saved = false;
          updatePositions(
            completeFinishRaceEntrants[i].position,
            completeFinishRaceEntrants[i].id,
          );
          completeFinishRaceEntrants[i].hr = "00";
          completeFinishRaceEntrants[i].min = "00";
          completeFinishRaceEntrants[i].sec = "00";
          completeFinishRaceEntrants[i].dn = "";
          completeFinishRaceEntrants[i].place = "";
          completeFinishRaceEntrants[i].finishDate = "";
          arr2.push(completeFinishRaceEntrants[i]);
        }
      }
      for (let i = 0; i < aboutFinishRaceEntrants.length; i++) {
        if (aboutFinishRaceEntrants[i].sailNum != "") {
          aboutFinishRaceEntrants[i].saved = false;
          updatePositions(
            aboutFinishRaceEntrants[i].position,
            aboutFinishRaceEntrants[i].id,
          );
          aboutFinishRaceEntrants[i].hr = "00";
          aboutFinishRaceEntrants[i].min = "00";
          aboutFinishRaceEntrants[i].sec = "00";
          aboutFinishRaceEntrants[i].dn = "";
          aboutFinishRaceEntrants[i].place = "";
          aboutFinishRaceEntrants[i].finishDate = "";
          arr2.push(aboutFinishRaceEntrants[i]);
        }
      }

      dispatch(actions.updateInitialFinishRaceEntrants(arr2));
      dispatch(actions.updateAboutFinishRaceEntrants([]));
      dispatch(actions.updateCompleteFinishRaceEntrants([]));

      //if(finishedEntrants.length==0){
      setImportTimes(times);
      // }
    }
  };

  const updatePositions = (targetPosition, itemId) => {
    dispatch(
      actions.updateCompleteFinishRaceEntrants(
        completeFinishRaceEntrants
          .map((item, index, array) => {
            if (item.id === itemId) {
              item.dn = "";
            }
            if (item.position > targetPosition) {
              item.position = item.position - 1;
            }
            return item;
          })
          .sort((a, b) =>
            a.position > b.position ? 1 : b.position > a.position ? -1 : 0,
          ),
      ),
    );
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();

    if (file) {
      fileReader.onload = function (event) {
        const text = event.target.result;
        csvFileToArray(text);
      };

      fileReader.readAsText(file);
    }
  };

  const downladSampleCSV = () => {
    // Create a string with CSV headers
    let columns = isPlace
      ? ["Boat", "Sail No", "Fleet", "Place", "DidNot"]
      : ["Boat", "Sail No", "Fleet", "HR", "MN", "SC", "DidNot"];

    if (caseOTBEntrant) {
      columns[0] = "Class";
    }

    const csvContent = `data:text/csv;charset=utf-8,${columns.join(",")}\n`;

    // Create a link element
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "FinishTimeImportSample.csv");

    // Append link to the body and trigger the download
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    handleClose();
  };

  function isNumeric(str) {
    if (typeof str != "string") return false;
    return !isNaN(str) && !isNaN(parseFloat(str));
  }

  const mapRowToEntrant = (row, index) => {
    let targetObj = {};
    targetObj["fleetName"] = row["fleet"];
    targetObj["boatName"] = row["boatname"];
    targetObj["sailNum"] = row["sailnum"];
    targetObj["id"] = row["sessionEntrantId"];
    targetObj["tesBID"] = row["tesBID"];
    targetObj["position"] = isPlace ? "" : 0;
    targetObj["editable"] = false;
    targetObj["hr"] = "00";
    targetObj["min"] = "00";
    targetObj["sec"] = "00";
    targetObj["date"] = "0000/00/00";
    targetObj["dn"] = "";
    targetObj["saved"] = false;

    return targetObj;
  };

  const handleDeleteRow = (id) => {
    setRows((prevRows) => prevRows.filter((row) => row.id !== id));
  };

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const updateRaceSessionId = (raceSessionId, isOverNightRace) => {
    console.log("UPdate race session", raceSessionId);
    setRaceSession(raceSessionId);
    setIsOnRace(isOverNightRace);
  };

  const updateRaceSessionNotes = (notes) => {
    // console.log("UPdate race session notes", notes);
    setRaceSessionNotes(notes);
  };

  const getRaceSessionStatus = async () => {
    if (raceSession && raceSession !== -1 && raceSession > 0) {
      try {
        const encryptedSessionId = encodeURIComponent(
          encrypt(JSON.stringify(raceSession)),
        );
        const STATUS_API =
          "api/clubs/FinishTime/flag?raceSession=" + encryptedSessionId;
        const response = await axiosInstance.get(STATUS_API);
        setProcessFlag(response.data.data);
        // if(!response.data.data){
        //  // setActiveTab("start");
        // }else{
        //   // setActiveTab("");
        // }
      } catch (error) {
        console.log(error);
        setProcessFlag(false);
        //setActiveTab("start");
      }
    }
  };

  React.useEffect(() => {
    if (!tabName) {
      setActiveTab("start");
    }
    if (raceSession && raceSession !== -1) {
      getRaceSessionStatus();
      fetchFleetDetails();
      fetchPreRaceSessionEntrants();
    }
  }, [raceSession]);

  const encryptedSessionId = encodeURIComponent(
    encrypt(JSON.stringify(raceSession)),
  );
  const fetchFleetDetails = async () => {
    try {
      const FLEET_API =
        "api/clubs/FinishTime/update?raceSession=" + encryptedSessionId;
      const response = await axiosInstance.get(FLEET_API);
      setPayload(response.data.data);
      deConstructResponse(response);
    } catch (error) {
      deConstructResponse([]);
      console.log(error);
    }
  };

  const fetchRaceSessionEntrants = async () => {
    const FLEET_API = `api/clubs/FinishTime/getEntrants?raceSession=${encryptedSessionId}`;

    try {
      const { data } = await axiosInstance.get(FLEET_API);
      const mappedEntrants = data.data.map(mapRowToEntrant);

      dispatch(actions.updateInitialFinishRaceEntrants(mappedEntrants));
      dispatch(actions.updateAboutFinishRaceEntrants([]));
      dispatch(actions.updateCompleteFinishRaceEntrants([]));

      setUnfinishedEntrants(mappedEntrants);
      setNumEntrants(mappedEntrants.length);

      // Optionally call populateNumericSailNums(mappedEntrants) if needed
    } catch (error) {
      console.error("Failed to fetch race session entrants:", error);
      setNumEntrants(-1);
    }
  };

  const fetchPreRaceSessionEntrants = async (param) => {
    if (raceSession != "" && raceSession > 0) {
      try {
        console.log(param);
        const FLEET_API =
          "api/clubs/FinishTime/prefinish?raceSession=" + encryptedSessionId;
        const response = await axiosInstance.get(FLEET_API);
        if (response.data.data.length == 0) {
          fetchRaceSessionEntrants();
        } else {
          let preFinished = response.data.data.filter((x) => x.status == 1);
          let finished = response.data.data.filter((x) => x.status == 2);
          let unfinished = response.data.data.filter((x) => x.status == 0);

          preFinished = preFinished.map((obj) => ({
            ...obj,
            editable: obj.editable == 1 ? true : false,
            place: obj.place === 0 ? "" : obj.place,
          }));
          finished = finished.map((obj, index) => ({
            ...obj,
            editable: obj.editable == 1 ? true : false,
            place: obj.place === 0 ? "" : obj.place,
            position: index + 1, // assign incremental numbers starting from 1
          }));
          unfinished = unfinished.map((obj) => ({
            ...obj,
            editable: false,
            place: obj.place === 0 ? "" : obj.place,
          }));

          dispatch(actions.updateInitialFinishRaceEntrants(unfinished));
          dispatch(actions.updateAboutFinishRaceEntrants(preFinished));
          dispatch(actions.updateCompleteFinishRaceEntrants(finished));
          setUnfinishedEntrants(unfinished);
          setNumEntrants(response.data.data.length);
          //   populateNumericSailNums(response.data.data);
        }
      } catch (error) {
        setNumEntrants(-1);
        dispatch(actions.updateInitialFinishRaceEntrants([]));
        dispatch(actions.updateAboutFinishRaceEntrants([]));
        dispatch(actions.updateCompleteFinishRaceEntrants([]));
        console.log(error);
      }
    }
  };

  useEffect(() => {
    let intervalId;
    let isMounted = true;

    const checkStatus = async () => {
      try {
        await getRaceSessionStatus();
      } catch (error) {
        console.error("Error checking race session status:", error);
      }
    };

    // Start the interval immediately
    checkStatus();
    intervalId = setInterval(checkStatus, 5000);

    // Cleanup function
    return () => {
      isMounted = false;
      clearInterval(intervalId);
    };
  }, [raceSession]); // Run when raceSession changes

  const deConstructResponse = (response) => {
    if (response.length === 0) {
      setRows([]);
      setSavedFleetDetails([]);
    } else {
      let detailArray = response.data.data.raceSessionsDetailList;
      const mapped = detailArray.map(mapToGridRow);
      setRows(mapped);
      setSavedFleetDetails(mapped.map((r) => ({ ...r })));
    }
  };
  const mapToGridRow = (obj) => {
    let newObj = {};
    newObj["id"] = obj.raceSessionDetailId;
    newObj["fleet"] = obj.fleet.fleet;
    newObj["hr"] = obj.startTimeHH;
    newObj["min"] = obj.startTimeMM;
    newObj["sec"] = obj.startTimeSS;
    return newObj;
  };

  const updateIsPlace = (flag) => {
    setIsPlace(flag);
  };

  const handlePenalties = (pen) => {
    setAllPenalties(pen);
  };

  const handleEventId = (event) => {
    setEventId(event.eventId);
    setProcessFlag(false);
    dispatch(actions.updateInitialFinishRaceEntrants([]));
    dispatch(actions.updateAboutFinishRaceEntrants([]));
    dispatch(actions.updateCompleteFinishRaceEntrants([]));
  };

  const handleSessionDate = (date) => {
    console.log("the date session", date);
    setSessionDate(date);
    if (!raceSessionIdQ) {
      setRaceSession(-1);
    }
    setProcessFlag(false);
    dispatch(actions.updateInitialFinishRaceEntrants([]));
    dispatch(actions.updateAboutFinishRaceEntrants([]));
    dispatch(actions.updateCompleteFinishRaceEntrants([]));
  };

  const populateNumericSailNums = (arrList) => {
    let arr1 = [];
    let obj = {};
    let v = "";
    arr1 = arrList.map((evt) => {
      v = evt.sailNum;
      obj[evt.id] = v?.replace(/\D/g, "");
      return evt;
    });
    //  setNumericSailMap(obj);
  };

  const handleProcessRowUpdate = (newRow) => {
    const updatedRows = rows.map((row) =>
      row.id === newRow.id ? { ...newRow } : row,
    );
    setRows(updatedRows);
    return newRow;
  };

  const handleSnackbarChange = (text, severity, open) => {
    setOpen(open);
    setSnackbar({ text: text, severity: severity });
  };

  const updateProcessFlag = (status) => {
    if (!status) setActiveTab("start");
    // setProcessEnable(status);
  };

  const [refetchRequest, setRefetchRequest] = useState(false);

  useEffect(() => {
    // setTimeout(() => {
    if (!isProcessClickedByMe && processFlag) {
      // console.log("TEST USEEFFECT isProcessClickedByMe processFlag if")
      setRefetchRequest(true);
    } else if (!isProcessClickedByMe && !processFlag && refetchRequest) {
      // console.log("TEST USEEFFECT isProcessClickedByMe processFlag else before")
      // fetchPreRaceSessionEntrants();
      // fetchPreRaceSessionEntrants("CLICKED BY ELSE IF");
      fetchPreRaceSessionEntrants();
      setRefetchRequest(false);
      // console.log("TEST USEEFFECT isProcessClickedByMe processFlag else after")
    }
    // }, 100);
  }, [isProcessClickedByMe, processFlag]);

  return (
    // <section
    //   className="main_Pages_box"
    //   style={{
    //     marginLeft: "0",
    //     marginRight: "0",
    //   }}
    // >
    // <Box className="main_Pages_box_inner">
    //   <CustomizedSnackbars
    //     severity={snackbar.severity}
    //     open={open}
    //     setShowToast={setOpen}
    //     text={snackbar.text}
    //   />
    <>
      <CustomizedSnackbars
        severity={snackbar.severity}
        open={open}
        setShowToast={setOpen}
        text={snackbar.text}
      />
      <Box className="inner_wrapper_pages">
        <Box>
          <Grid container>
            <Grid item md={6} className="ty_page_heading">
              <InnerPageheading headerName="Finish time entry" />
            </Grid>
          </Grid>
        </Box>
        <Box className="InnerPage_area">
          <Scrollbars
            autoHide
            sx={{
              height: "100%",
            }}
          >
            <FinishTimeEntryHeaderBox
              setRaceSessions={updateRaceSessionId}
              setRaceSessionNotes={updateRaceSessionNotes}
              setIsPlace={updateIsPlace}
              setPenalties={handlePenalties}
              setEventId={handleEventId}
              setDate={handleSessionDate}
              setCaseOTBEntrant={setCaseOTBEntrant}
            />

            {/* Overlay Screen */}
            {!raceSession && (
              <Box>
                <Alert severity="warning">No Session Found.</Alert>
              </Box>
            )}
            <>
              {raceSession > 0 && (
                <Card
                  sx={{
                    width: "100%",
                    maxWidth: "7xl",
                    margin: "auto",
                    padding: "0",
                  }}
                  className="FinishTimeEntryNew"
                >
                  <CardContent
                    sx={{
                      // padding: 3,
                      padding: "0",
                      position: "relative",
                      height: `${processFlag ? "300px" : "auto"}`,
                    }}
                    className="ty_finishTimeEntry_container"
                  >
                    {processFlag && (
                      <Box
                        style={{
                          textAlign: "center",
                          color: "var(--ty-primary-hovercolor)",
                          position: "absolute",
                          height: "100%",
                          width: "100%",
                          background: "#FFFFFFD6",
                          zIndex: "100",
                          overflow: "hidden",
                        }}
                      >
                        <Typography sx={{ fontSize: "var(--font_size24)" }}>
                          Please wait results are already being processed...
                        </Typography>
                        <Box my={2}>
                          <CircularProgress size={60} />
                        </Box>
                      </Box>
                    )}
                    <Box
                      sx={{
                        borderBottom: 1,
                        borderColor: "divider",
                        display: "flex",
                        // alignItems: "center",
                        justifyContent: "space-between",
                        flexDirection: {
                          xs: "column-reverse",
                          md: "column-reverse",
                          lg: "row",
                        },
                        gap: { xs: "0.5rem", md: "0.5rem", lg: "0" },
                      }}
                    >
                      {!processFlag && raceSession > 0 ? (
                        <Tabs
                          value={activeTab}
                          onChange={handleChange}
                          aria-label="race timing tabs"
                          scrollButtons="auto"
                          role="navigation"
                          variant="scrollable"
                          className="ty_tabs_nav"
                        >
                          <Tab label="Start Time" value="start" />
                          {isPlace !== true && (
                            <Tab
                              label="Real Time Capture"
                              value="realtime"
                              disabled={isPlace === true}
                            />
                          )}
                          <Tab label="Manual Times Entry" value="manual" />
                          <Tab label="Session Notes" value="session" />
                        </Tabs>
                      ) : (
                        <></>
                      )}

                      {/* <Hidden mdDown> */}
                      <Box
                        sx={{
                          minWidth: "max-content",
                          width: {
                            xs: "99%",
                            md: "99%",
                            lg: "max-content",
                            xl: "max-content",
                          },
                          padding: {
                            xs: "0",
                            md: "0",
                            lg: "0 10px",
                            xl: "0 10px",
                          },
                        }}
                        className="import_time_contianer"
                      >
                        {!processFlag && raceSession > 0 && (
                          <Button
                            aria-describedby={id}
                            onClick={handleClick}
                            className="ty_secondary_btn"
                            disabled={numEntrants <= 0}
                            sx={{
                              fontWeight: "600",
                              // height: "40px",
                              marginBottom: {
                                xl: "0px",
                                lg: "0px",
                                md: "0px",
                                sm: "0px",
                                xs: "10px",
                              },
                            }}
                          >
                            Import Times
                          </Button>
                        )}
                        <Popover
                          id={id}
                          open={openUploadFile}
                          anchorEl={anchorEl}
                          onClose={handleClose}
                          className="select_source_main"
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "right",
                          }}
                          transformOrigin={{
                            vertical: "top",
                            horizontal: "right",
                          }}
                          sx={{
                            borderRadius: "20px",
                          }}
                        >
                          <div
                            className="select_source_div"
                            style={{
                              width: "368px",
                            }}
                          >
                            <Box>
                              <div>
                                <FormLabel
                                  className="ty-uppercase-label mb-0"
                                  sx={{
                                    display: "block",
                                    width: "100%",
                                    marginBottom: "0px",
                                    paddingLeft: "0.5rem",
                                    paddingTop: "0.5rem",
                                  }}
                                >
                                  Select Source
                                </FormLabel>
                                <Box className="cst_hr" />
                              </div>
                              <Box>
                                <div
                                  className="select_popup_div"
                                  style={{
                                    padding: "0px 16px",
                                    display: "flex",
                                    gap: "16px",
                                    flexDirection: "column",
                                  }}
                                >
                                  <Box>
                                    {!file && (
                                      <Box
                                        onDragOver={(e) => e.preventDefault()}
                                        onDrop={(e) => {
                                          e.preventDefault();
                                          handleOnChange({
                                            target: {
                                              files: e.dataTransfer.files,
                                            },
                                          });
                                        }}
                                        style={{ cursor: "pointer" }}
                                        className="file_upload_div_section"
                                      >
                                        <input
                                          type="file"
                                          style={{ display: "none" }}
                                          id="fileInput"
                                          accept=".csv"
                                          onChange={handleOnChange}
                                        />
                                        <label
                                          htmlFor="fileInput"
                                          className="upload_btn"
                                        >
                                          <Button variant="" component="div">
                                            <ul
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                gap: "10px",
                                                listStyle: "none",
                                                padding: "0",
                                                margin: "0",
                                              }}
                                            >
                                              <li
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                }}
                                              >
                                                <SaveAltIcon />
                                              </li>
                                              <li>
                                                Drag and drop or click to select
                                                file
                                              </li>
                                            </ul>
                                          </Button>
                                        </label>
                                      </Box>
                                    )}
                                    {file && (
                                      <Box mt={0}>
                                        <Box className="file_uploading">
                                          <Box>
                                            <Box
                                              sx={{
                                                display: "flex",
                                                gap: "16px",
                                                alignItems: "center",
                                              }}
                                            >
                                              <div className="csv_file">
                                                <img
                                                  src="/assets/icons/csv_icon.svg"
                                                  style={{
                                                    maxWidth: "100%",
                                                  }}
                                                />
                                              </div>
                                              <Typography variant="body1">
                                                {fileName}
                                              </Typography>
                                            </Box>
                                          </Box>
                                          <Box>
                                            <ClearIcon
                                              className="clearall_btn"
                                              onClick={handleFileClear}
                                              sx={{
                                                display: "flex",
                                                padding: "0px",
                                                alignItems: "center",
                                              }}
                                            />
                                          </Box>
                                        </Box>
                                      </Box>
                                    )}
                                  </Box>
                                </div>
                                <>
                                  <Box mt={2} mb={2}>
                                    <Accordion className="cst_accordion">
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                      >
                                        <InfoOutlinedIcon className="information_icon" />
                                        <Typography className="important_notes_heading">
                                          Important Note
                                        </Typography>
                                      </AccordionSummary>
                                      <AccordionDetails
                                        sx={{
                                          maxHeight: "115px",
                                          overflowY: "scroll",
                                        }}
                                      >
                                        <List>
                                          <ListItem>
                                            “HR” - must be a valid number
                                            between 0 and 23.
                                          </ListItem>
                                          <ListItem>
                                            “MIN” - must be a valid number
                                            between 0 and 60.
                                          </ListItem>
                                          <ListItem>
                                            “SEC” - must be a valid number
                                            between 0 and 60.
                                          </ListItem>
                                          <ListItem>
                                            “DidNot” - must include a valid
                                            penalty code as per the RRS.
                                          </ListItem>
                                          <ListItem>
                                            “Sail No.” - must be a valid sail
                                            number that matches an existing
                                            entrant.
                                          </ListItem>
                                          <ListItem>
                                            “Boat Name” - must be a valid boat
                                            name that matches an existing
                                            entrant.
                                          </ListItem>
                                          <ListItem>
                                            “Fleet” - must be a valid fleet that
                                            matches an existing entrant.
                                          </ListItem>
                                          <ListItem>
                                            “Place” - must be a valid numeric
                                            value.
                                          </ListItem>
                                        </List>
                                      </AccordionDetails>
                                    </Accordion>

                                    <Box
                                      sx={{
                                        textAlign: "center",
                                        margin: "10px auto",
                                        maxWidth: "90%",
                                      }}
                                    >
                                      <Button
                                        size="small"
                                        className="ty_secondary_btn"
                                        onClick={downladSampleCSV}
                                      >
                                        Download Sample CSV{" "}
                                        <DownloadIcon sx={{ height: "20px" }} />
                                      </Button>
                                    </Box>
                                  </Box>
                                </>
                                <Box
                                  className="cst_hr"
                                  sx={{
                                    marginTop: "0px",
                                  }}
                                />

                                <div className="button_group_div">
                                  <Grid
                                    container
                                    justifyContent="flex-end"
                                    sx={{
                                      display: "flex",
                                      gap: "8px",
                                    }}
                                  >
                                    <Grid item>
                                      <Button
                                        className="ty_secondary_btn"
                                        onClick={handleClose}
                                      >
                                        Cancel
                                      </Button>
                                    </Grid>
                                    <Grid item>
                                      <Button
                                        className="ty_primary_btn"
                                        onClick={(e) => {
                                          handleOnSubmit(e);
                                        }}
                                      >
                                        Import
                                      </Button>
                                    </Grid>
                                  </Grid>
                                </div>
                              </Box>
                            </Box>
                          </div>
                        </Popover>
                      </Box>
                      {/* </Hidden> */}
                    </Box>
                    <Box className="ty_tab-details">
                      {raceSession > 0 && activeTab === "start" && (
                        <StartTime
                          caseOTBEntrant={caseOTBEntrant}
                          fleetDetails={rows}
                          racePayload={payload}
                          activateSnackbarTab={handleSnackbarChange}
                          onStartTimeUpdate={(updatedRows) =>
                            setSavedFleetDetails(
                              updatedRows.map((r) => ({ ...r })),
                            )
                          }
                        />
                      )}

                      {activeTab === "realtime" && (
                        <RealTimeCapture
                          isOnWaterDisabled={isOnWaterDisabled}
                          caseOTBEntrant={caseOTBEntrant}
                          allUnfinished={unfinishedEntrants}
                          penalties={allPenalties}
                          event={eventId}
                          session={raceSession}
                          raceSessionsDate={sessionDate}
                          place={isPlace}
                          overnight={isOnRace}
                          activateSnackbarTab={handleSnackbarChange}
                          setProcessFlag={setProcessFlag}
                          // setIsClicked={setIsClicked}
                          setIsProcessClickedByMe={setIsProcessClickedByMe}
                          isProcessClickedByMe={isProcessClickedByMe}
                          fetchPreRaceSessionEntrants={
                            fetchPreRaceSessionEntrants
                          }
                          setRefetchRequest={setRefetchRequest}
                          numEntrants={numEntrants}
                          changeSort={changeSort}
                          fleetDetails={rows}
                          savedFleetDetails={savedFleetDetails}
                          setActiveTab={setActiveTab}
                          //onWaterTesBoatIds={onWaterTesBoatIds}
                          //handleLoadOnWater={handleLoadOnWater}
                          //isOnWaterDisabled={isOnWaterDisabled}
                        />
                      )}
                      {activeTab === "manual" && allPenalties.length > 0 && (
                        <FinishTime
                          isOnWaterDisabled={isOnWaterDisabled}
                          caseOTBEntrant={caseOTBEntrant}
                          captureTime={captureTime}
                          allUnfinished={unfinishedEntrants}
                          penalties={allPenalties}
                          event={eventId}
                          session={raceSession}
                          raceSessionsDate={sessionDate}
                          place={isPlace}
                          overnight={isOnRace}
                          activateSnackbarTab={handleSnackbarChange}
                          setRefetchRequest={setRefetchRequest}
                          setProcessFlag={setProcessFlag}
                          numEntrants={numEntrants}
                          changeSort={changeSort}
                          fleetDetails={rows}
                          savedFleetDetails={savedFleetDetails}
                          setActiveTab={setActiveTab}
                          //onWaterTesBoatIds={onWaterTesBoatIds}
                          //handleLoadOnWater={handleLoadOnWater}
                          //isOnWaterDisabled={isOnWaterDisabled}
                        />
                      )}
                      {activeTab === "session" && (
                        <SessionNotesTab
                          caseOTBEntrant={caseOTBEntrant}
                          sessionId={raceSession}
                          sessionNote={raceSessionNotes}
                          updateNotes={updateRaceSessionNotes}
                          event={eventId}
                          raceSessionsDate={sessionDate}
                        />
                      )}
                    </Box>
                  </CardContent>
                </Card>
              )}
              {/* <Hidden mdUp>
                  <Box>
                    <Button
                      aria-describedby={id}
                      onClick={handleClick}
                      className="ty_secondary_btn"
                      sx={{
                        fontWeight: "600",
                        height: "40px",
                        marginBottom: {
                          xl: "0px",
                          lg: "0px",
                          md: "0px",
                          sm: "0px",
                          xs: "10px",
                        },
                      }}
                    >
                      Import Times
                    </Button>
                    <Popover
                      id={id}
                      open={openUploadFile}
                      anchorEl={anchorEl}
                      onClose={handleClose}
                      className="select_source_main"
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "right",
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                      sx={{
                        borderRadius: "20px",
                      }}
                    >
                      <div
                        className="select_source_div"
                        style={{
                          width: "368px",
                        }}
                      >
                        <Box>
                          <div
                            style={{
                              padding: "16px 16px 0px 16px",
                            }}
                          >
                            <FormLabel
                              className="ty-uppercase-label"
                              sx={{
                                display: "block",
                                width: "100%",
                                marginBottom: "10px",
                              }}
                            >
                              Select Source
                            </FormLabel>
                            <Box className="cst_hr" />
                          </div>
                          <Box>
                            <div
                              className="select_popup_div"
                              style={{
                                padding: "0px 16px",
                                display: "flex",
                                gap: "16px",
                                flexDirection: "column",
                              }}
                            >
                              <Box>
                                {!file && (
                                  <Box
                                    onDragOver={(e) => e.preventDefault()}
                                    onDrop={(e) => {
                                      e.preventDefault();
                                      handleOnChange({
                                        target: {
                                          files: e.dataTransfer.files,
                                        },
                                      });
                                    }}
                                    style={{ cursor: "pointer" }}
                                    className="file_upload_div_section"
                                  >
                                    <input
                                      type="file"
                                      style={{ display: "none" }}
                                      id="fileInput"
                                      accept=".csv"
                                      onChange={handleOnChange}
                                    />
                                    <label
                                      htmlFor="fileInput"
                                      className="upload_btn"
                                    >
                                      <Button variant="" component="div">
                                        <ul
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            gap: "10px",
                                            listStyle: "none",
                                            padding: "0",
                                            margin: "0",
                                          }}
                                        >
                                          <li
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                            }}
                                          >
                                            <SaveAltIcon />
                                          </li>
                                          <li>
                                            Drag and drop or click to select
                                            file
                                          </li>
                                        </ul>
                                      </Button>
                                    </label>
                                  </Box>
                                )}
                                {file && (
                                  <Box mt={0}>
                                    <Box className="file_uploading">
                                      <Box>
                                        <Box
                                          sx={{
                                            display: "flex",
                                            gap: "16px",
                                            alignItems: "center",
                                          }}
                                        >
                                          <div className="csv_file">
                                            <img
                                              src="/assets/icons/csv_icon.svg"
                                              style={{ maxWidth: "100%" }}
                                            />
                                          </div>
                                          <Typography variant="body1">
                                            {fileName}
                                          </Typography>
                                        </Box>
                                      </Box>
                                      <Box>
                                        <ClearIcon
                                          className="clearall_btn"
                                          onClick={handleFileClear}
                                          sx={{
                                            display: "flex",
                                            padding: "0px",
                                            alignItems: "center",
                                          }}
                                        />
                                      </Box>
                                    </Box>
                                  </Box>
                                )}
                              </Box>
                            </div>
                            <>
                              <Box mt={2} mb={2}>
                                <Accordion className="cst_accordion">
                                  <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                  >
                                    <InfoOutlinedIcon className="information_icon" />
                                    <Typography className="important_notes_heading">
                                      Important Note
                                    </Typography>
                                  </AccordionSummary>
                                  <AccordionDetails
                                    sx={{
                                      maxHeight: "115px",
                                      overflowY: "scroll",
                                    }}
                                  >
                                    <List>
                                      <ListItem>
                                        “HR” - must be a valid number between 0
                                        and 23.
                                      </ListItem>
                                      <ListItem>
                                        “MIN” - must be a valid number between 0
                                        and 60.
                                      </ListItem>
                                      <ListItem>
                                        “SEC” - must be a valid number between 0
                                        and 60.
                                      </ListItem>
                                      <ListItem>
                                        “DidNot” - must include a valid penalty
                                        code as per the RRS.
                                      </ListItem>
                                      <ListItem>
                                        “Sail No.” - must be a valid sail number
                                        that matches an existing entrant.
                                      </ListItem>
                                      <ListItem>
                                        “Boat Name” - must be a valid boat name
                                        that matches an existing entrant.
                                      </ListItem>
                                      <ListItem>
                                        “Fleet” - must be a valid fleet that
                                        matches an existing entrant.
                                      </ListItem>
                                      <ListItem>
                                        “Place” - must be a valid numeric value.
                                      </ListItem>
                                    </List>
                                  </AccordionDetails>
                                </Accordion>

                                <Box
                                  sx={{
                                    textAlign: "center",
                                    margin: "10px 0",
                                  }}
                                >
                                  <Button
                                    size="small"
                                    className="ty_secondary_btn"
                                    onClick={downladSampleCSV}
                                  >
                                    Download Sample CSV{" "}
                                    <DownloadIcon sx={{ height: "20px" }} />
                                  </Button>
                                </Box>
                              </Box>
                            </>
                            <Box
                              className="cst_hr"
                              sx={{
                                marginTop: "0px",
                              }}
                            />

                            <div className="button_group_div">
                              <Grid
                                container
                                justifyContent="flex-end"
                                sx={{
                                  display: "flex",
                                  gap: "8px",
                                }}
                              >
                                <Grid item>
                                  <Button
                                    className="ty_secondary_btn"
                                    onClick={handleClose}
                                  >
                                    Cancel
                                  </Button>
                                </Grid>
                                <Grid item>
                                  <Button
                                    className="ty_primary_btn"
                                    onClick={(e) => {
                                      handleOnSubmit(e);
                                    }}
                                  >
                                    Import
                                  </Button>
                                </Grid>
                              </Grid>
                            </div>
                          </Box>
                        </Box>
                      </div>
                    </Popover>
                  </Box>
                </Hidden> */}
            </>
          </Scrollbars>
        </Box>
      </Box>
    </>
    // </Box>
    // </section>
  );
}